import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { AdCard } from '@/components/marketplace/AdCard';

export default function FavoritesPage() {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => { api.get('/me/favorites').then(r => setAds(r.data)).finally(() => setLoading(false)); }, []);
    return (
        <div className="space-y-4">
            <h1 className="text-xl font-semibold tracking-tight">Favoritos</h1>
            {loading ? <div className="text-sm text-muted-foreground">Cargando…</div> :
            ads.length === 0 ? <div className="text-sm text-muted-foreground">Sin favoritos aún.</div> :
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-5" data-testid="favs-grid">
                {ads.map(a => <AdCard key={a.id} ad={a} />)}
            </div>}
        </div>
    );
}
